<a class="ListItem" :href="getUrl()" target="_new" @mouseover="onMouseOver" @mouseout="onMouseOut">
   {{getLabel()}}
</a>
